var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"value":_vm.loading,"persistent":"","width":"300"}},[_c('v-container',{staticClass:"pa-12 white text-center"},[_c('LoadingSpinner'),_vm._v(" Loading... ")],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }